/* ============================================================================
   3D BUILDER  -  PAID ADD-ON PRICES AND THE RECEIPT

   Three jobs:
     1. put the price on every swatch that costs extra, before it is clicked
     2. repeat it beside the group's current selection
     3. replace the section's plain "Includes" list with a receipt that shows
        the base price, each extra, and the arithmetic to the total - and move
        it to the bottom of the panel, just above Add to cart

   WHY THE MAP IS RESTATED HERE
   pm-home.liquid already knows all of this - it has ADDON_FOR and
   ADDON_VARIANTS - but they are locals inside an IIFE, not exposed on window.
   Rather than reopen a 1400-line working configurator to hoist two variables,
   the map is restated below. That means it can drift: if the Builder Add-ons
   prices change in Shopify, the CART will still be right and these figures
   will be stale. PRICES is the one place to fix that.

   Verified against the Builder Add-ons product:
     ODI Plate 1.00 | Guts Seat Cover 1.00 | EBMX Controller 2.00
     Chi Battery 2.00 | Motor Cover 1.00
   ============================================================================ */
(function () {

  /* builder group -> the value that costs extra -> price in cents */
  var PRICES = {
    'Plate Fitted': { 'ODI': 100 },
    'Seat':         { 'Guts Cover': 100 },
    'Controller':   { 'EBMX': 200 },
    'Battery':      { 'Chi': 200 },
    'Motor':        { 'Motor Cover': 100 }
  };

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function plus(c) { return '+$' + (c / 100).toFixed(2); }

  /* ---- 1. The price on the swatch, before you click it ------------------- */
  function tagSwatches(root) {
    for (var group in PRICES) {
      if (!Object.prototype.hasOwnProperty.call(PRICES, group)) continue;
      var map = PRICES[group];
      var btns = root.querySelectorAll('.pm-sw--prop[data-prop="' + group + '"]');
      for (var i = 0; i < btns.length; i++) {
        var cents = map[btns[i].getAttribute('data-value')];
        if (!cents || btns[i].querySelector('.pm-plus')) continue;
        var tag = document.createElement('span');
        tag.className = 'pm-plus';
        tag.textContent = '+$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
        btns[i].appendChild(tag);
      }
    }
  }

  /* ---- 2. The price beside the group's current selection ------------------
     The badge is a SIBLING of .pm-optval, never a child. The section rewrites
     that element's textContent on every click and reads it back to work out
     what is selected, so a badge inside it would be both wiped and counted as
     part of the option's name. */
  function tagHeaders(root) {
    var labels = root.querySelectorAll('.pm-optval[data-prop]');
    for (var i = 0; i < labels.length; i++) {
      var lab = labels[i];
      var badge = lab.nextElementSibling;
      if (!badge || badge.className.indexOf('pm-plus') === -1) {
        badge = document.createElement('span');
        badge.className = 'pm-plus';
        lab.parentNode.insertBefore(badge, lab.nextSibling);
      }
      var map = PRICES[lab.getAttribute('data-prop')];
      var cents = map ? map[lab.textContent.trim()] : null;
      if (cents) {
        badge.textContent = '+$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
        badge.style.display = '';
      } else {
        badge.textContent = '';
        badge.style.display = 'none';
      }
    }
  }

  /* ---- 3. Paid groups last ----------------------------------------------
     Every .pm-optgrp shares one wrapper of its own, so appending inside that
     parent reorders the list without pushing anything past Add to cart. */
  var ordered = false;
  function orderPaidLast(root) {
    if (ordered) return;
    var labels = root.querySelectorAll('.pm-optval[data-prop]');
    var paid = [];
    for (var i = 0; i < labels.length; i++) {
      if (!PRICES[labels[i].getAttribute('data-prop')]) continue;
      var grp = labels[i].closest ? labels[i].closest('.pm-optgrp') : null;
      if (grp) paid.push(grp);
    }
    if (!paid.length) return;
    for (var j = 0; j < paid.length; j++) {
      if (paid[j].parentNode) paid[j].parentNode.appendChild(paid[j]);
    }
    ordered = true;
  }

  /* ---- 4. The receipt ----------------------------------------------------
     The section creates #pm-addon-list directly under the price and fills it
     with a bare list of extras. It is moved to the bottom of the panel, above
     Add to cart, and its contents replaced with a receipt.

     The base price is not published anywhere readable, so it is derived: the
     section has already written base + extras into #pm-price, and the extras
     are known here, so base = total - extras. That is why this has to run
     AFTER the section's own handler, not before. */
  function selectedExtras(root) {
    var out = [];
    var labels = root.querySelectorAll('.pm-optval[data-prop]');
    for (var i = 0; i < labels.length; i++) {
      var map = PRICES[labels[i].getAttribute('data-prop')];
      if (!map) continue;
      var value = labels[i].textContent.trim();
      var cents = map[value];
      if (cents) out.push({ name: value, cents: cents });
    }
    return out;
  }

  function readPrice() {
    var el = document.getElementById('pm-price');
    if (!el) return null;
    var m = String(el.textContent).replace(/[^0-9.]/g, '');
    if (!m) return null;
    return Math.round(parseFloat(m) * 100);
  }

  function row(name, figure, cls) {
    return '<div class="' + cls + '"><span class="pm-rcpt-n">' + name +
           '</span><i class="pm-rcpt-l"></i><b class="pm-rcpt-f">' + figure + '</b></div>';
  }

  function renderReceipt(root) {
    var box = document.getElementById('pm-addon-list');
    if (!box) return;

    /* Move it once, to just above the button. */
    var panel = root.querySelector('.pm-builder-opts');
    var btn = root.querySelector('.pm-addcart');
    if (panel && btn && box.nextElementSibling !== btn) {
      panel.insertBefore(box, btn);
    }

    var total = readPrice();
    if (total === null) { box.innerHTML = ''; return; }

    var extras = selectedExtras(root);
    var extrasSum = 0;
    for (var i = 0; i < extras.length; i++) extrasSum += extras[i].cents;
    var base = total - extrasSum;

    var nameEl = root.querySelector('.pm-builder-name');
    var baseName = nameEl ? nameEl.textContent.trim() : 'Base model';

    var html = '<div class="pm-rcpt">';
    html += '<div class="pm-rcpt-h">Build summary</div>';
    html += row(baseName, money(base), 'pm-rcpt-r');
    for (var j = 0; j < extras.length; j++) {
      html += row(extras[j].name, plus(extras[j].cents), 'pm-rcpt-r pm-rcpt-r--add');
    }
    html += row('Total', money(total), 'pm-rcpt-t');
    html += '</div>';

    box.innerHTML = html;
  }

  function run() {
    var root = document.getElementById('pm-builder');
    if (!root) return false;
    if (!root.querySelector('.pm-sw--prop')) return false;  /* UI not built yet */
    orderPaidLast(root);
    tagSwatches(root);
    tagHeaders(root);
    renderReceipt(root);
    return true;
  }

  var ticks = 0;
  var poll = window.setInterval(function () {
    ticks++;
    if (run() || ticks > 120) window.clearInterval(poll);
  }, 250);

  /* The section also re-renders on click, on a 0ms timeout. This waits a beat
     longer so it lands second and its receipt is the one that survives. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.pm-sw')) return;
    window.setTimeout(run, 30);
  });

  window.__pmAddons = { apply: run, prices: PRICES };
})();
